<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :title="'维度分组-'+modalData.initName"
        :show-close="false"
        width="550px"
        append-to-body
        destroy-on-close
        :before-close="handleClose">
        <div>
            <el-form ref="form" :model="formItem" :rules="rules" label-width="100px" class="pr40" :disabled="modalData['type'] == 'info'">
                <el-form-item label="名称" prop="display_name">
                    <el-input v-model.trim="formItem.display_name" maxlength="20" show-word-limit placeholder="请输入账户名称"
                        style="width:230px;" clearable />
                </el-form-item>
                <el-form-item v-if="modalData.name=='date'" prop="sum_type" label="汇总方式" class="label-required">
                    <el-select v-model="formItem.sum_type" @change="changeSumType" placeholder="请选择">
                        <el-option label="天" value="day"></el-option>
                        <el-option label="周" value="week"></el-option>
                        <el-option label="月" value="month"></el-option>
                        <el-option label="季度" value="quarter"></el-option>
                        <el-option label="年" value="year"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="modalData.name=='yy_type'" prop="start_date_dimension" label="运营类型维度" class="label-required">
                    <ESelect v-model="formItem.yy_type_dimension" @change="checkAppleSelect" placeholder="请选择">
                        <el-option
                            v-for="item in yyTypeDimensionList"
                            :key="item.name"
                            :label="item.display_name"
                            :value="item.name">
                        </el-option>
                    </ESelect>
                </el-form-item>
                <el-form-item v-if="modalData.name=='start_date'" prop="start_date_dimension" label="开投日期维度" class="label-required">
                    <ESelect v-model="formItem.start_date_dimension" @change="checkAppleSelect" placeholder="请选择">
                        <el-option
                            v-for="item in dimensionList"
                            :key="item.name"
                            :label="item.display_name"
                            :value="item.name">
                        </el-option>
                    </ESelect>
                </el-form-item>
                <el-form-item v-else-if="modalData.name=='create_date'" prop="create_date_dimension" label="创建日期维度" class="label-required">
                    <ESelect v-model="formItem.create_date_dimension" @change="checkAppleSelect" placeholder="请选择">
                        <el-option
                            v-for="item in createDimensionList"
                            :key="item.name"
                            :label="item.display_name"
                            :value="item.name">
                        </el-option>
                    </ESelect>
                </el-form-item>
                <el-form-item label="排序条件" prop="order_by" :class="modalData.name=='date'?'label-required':''">
                    <ESelect v-model="formItem.order_by" @change="changeOrderBy" @clear="clearOrderBy" clearable filterable placeholder="请选择">
                        <el-option value="date" label="数据日期" v-if="modalData.name=='date'"></el-option>
                        <el-option
                            v-for="item in availableFieldList"
                            :key="item.name"
                            :label="item.display_name"
                            :disabled="isCompare&&item.isSumField"
                            :title="isCompare&&item.isSumField?'累计指标对比时维度排序':''"
                            :value="item.name">
                        </el-option>
                    </ESelect>
                </el-form-item>
                <template v-if="modalData.name=='date'||formItem.order_by">
                    <el-form-item label="排序方式" prop="order_type" class="label-required">
                        <el-radio v-model="formItem.order_type" label="desc">降序</el-radio>
                        <el-radio v-model="formItem.order_type" label="asc">升序</el-radio>
                    </el-form-item>
                    <el-form-item v-if="modalData.name!='date'" label="展示数量" prop="show_num" class="label-required">
                        <el-radio v-model="formItem.show_type" label="1">全部</el-radio>
                        <el-radio v-model="formItem.show_type" label="2">自定义<span v-if="formItem.show_type==2" class="pl6 text-color-gray">输入要展示的数量</span></el-radio>
                        <p class="ml80">
                            <el-input-number v-if="formItem.show_type=='2'" v-model="formItem.show_num" size="mini" controls-position="right" :min="1" :step="1" placeholder="输入要展示的数量"></el-input-number>
                        </p>
                    </el-form-item>
                </template>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" class="action-btn ml20">确认</el-button>
        </div>
    </el-dialog>
</template>

<script>

    export default {
        name: "DimensionModal",
        components: {},
        props: {
            modalData:{
                type:Object,
                required:true,
            },
            shownField:{
                type:Array,
                required: true,
            },
            hiddenField:{
                type:Array,
                required: true,
            },
            dimensions:{
                type:Array,  //选中维度
                required: true,
            },
            allField:{
                type:Array,  //全部指标
                required: true,
            },
            platId:[String,Number],
            isTimeFilter:{
                required: false,
                type:Boolean,
                default:false,
            },
            isCompare:{
                required: false,
                type:Boolean,
                default:false,
            },
            allDimensions: {
                type:Array,  //全部维度
                required: true,
            },
            selectTarget: {
                type:Array,  //选中指标
                required: true,
            }
        },
        data() {
            return {
                dialogVisible: false,
                formItem: {
                    sum_type:'',    // 汇总方式
                    start_date_dimension:'app_name',        //开投日期维度:取维度字段，默认按产品
                    create_date_dimension:'account_create_time',        //创建日期维度:取维度字段
                    yy_type_dimension:'bloc_yy_type',       // 运营类型维度:取维度字段
                    order_by:'',    // 排序条件
                    order_type:'desc',    // 排序方式
                    show_type:'1',    // 展示数量方式 1-全部，2-自定义
                    show_num:null,    // 展示数量
                    display_name: '' // 维度名称
                },
                rules: {
                    sum_type: [],
                    start_date_dimension: [],
                    order_by: [],
                    order_type: [],
                    show_num: [],
                    display_name: [
                        { required: true, message: '请输入名称', trigger: 'blur' }
                    ],
                },
                dimensionList:[],
                createDimensionList:[],
                yyTypeDimensionList:[],
                allFieldList:[],
                lastSelectVal:'',
            }
        },
        computed: {
            availableFieldList(){
                if(!this.isTimeFilter) return this.allFieldList;
                if(this.isCompare&&!this.isTimeFilter){
                    return this.allFieldList;
                }
                console.log('---', this.allFieldList.filter(field=>((field.config||{}).time_type||[]).includes('hour')))
                return this.allFieldList.filter(field=>((field.config||{}).time_type||[]).includes('hour'));
            },
        },
        watch: {
            dialogVisible(n) {
                if (!n) {
                    window.removeEventListener('keydown', this.keydownFn)
                }else {
                    window.addEventListener('keydown', this.keydownFn);
                }
            }
        },
        methods: {
            keydownFn(e) {
                 if (e.keyCode === 13) {
                    this.handleSubmit()
                }
            },
            handleClose() {
                this.dialogVisible = false;
                this.$nextTick(()=>{
                    this.resetForm();
                })
            },
            resetForm() {
                this.formItem.sum_type = '';
                this.formItem.start_date_dimension = 'app_name';
                this.formItem.create_date_dimension = this.platId=='9'?'plan_create_date':'account_create_time';
                this.formItem.yy_type_dimension = 'bloc_yy_type';
                this.formItem.order_by = '';
                this.formItem.order_type = 'desc';
                this.formItem.show_type = '1';
                this.formItem.show_num = null;
                this.formItem.display_name = ''
                this.$refs['form'].resetFields();
            },
            makeDimensionList(){
                if(this.platId=='3'){
                    this.dimensionList = [
                        {
                            display_name:'按集团',
                            name:'bloc_name',
                        },
                        {
                            display_name:'按客户',
                            name:'company_name',
                        },
                        {
                            display_name:'按账户',
                            name:'account_name',
                        },
                        {
                            display_name:'按项目',
                            name:'project_name',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_name',
                        },
                        {
                            display_name:'按产品',
                            name:'app_name',
                        },
                        {
                            display_name:'按计划',
                            name:'plan_name',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_name',
                        },
                        {
                            display_name:'按广告',
                            name:'ad_name',
                        },
                        {
                            display_name:'按创意',
                            name:'idea_name',
                        },
                    ];
                    this.createDimensionList = [
                        {
                            display_name:'按账户',
                            name:'account_create_time',
                        },
                        {
                            display_name:'按计划',
                            name:'plan_create_date',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_create_date',
                        },
                        {
                            display_name:'按广告',
                            name:'ad_create_date',
                        },
                        {
                            display_name:'按创意',
                            name:'idea_create_date',
                        },
                    ];
                    this.yyTypeDimensionList = [
                        {
                            name:'bloc_yy_type',
                            display_name:'按集团',
                        },
                        {
                            name:'company_yy_type',
                            display_name:'按客户',
                        },
                        {
                            name:'account_yy_type',
                            display_name:'按账户',
                        },
                        {
                            name:'project_yy_type',
                            display_name:'按项目',
                        },
                        {
                            name:'subproject_yy_type',
                            display_name:'按推广',
                        },
                        {
                            name:'app_yy_type',
                            display_name:'按产品',
                        },
                        {
                            name:'plan_yy_type',
                            display_name:'按计划',
                        },
                        {
                            name:'adgroup_yy_type',
                            display_name:'按广告组',
                        },
                        {
                            name:'ad_yy_type',
                            display_name:'按广告',
                        },
                        {
                            name:'idea_yy_type',
                            display_name:'按创意',
                        },
                    ];
                }else if(this.platId=='4'){
                    this.dimensionList = [
                        {
                            display_name:'按集团',
                            name:'bloc_name',
                        },
                        {
                            display_name:'按客户',
                            name:'company_name',
                        },
                        {
                            display_name:'按账户',
                            name:'account_name',
                        },
                        {
                            display_name:'按项目',
                            name:'project_name',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_name',
                        },
                        {
                            display_name:'按产品',
                            name:'app_name',
                        },
                        {
                            display_name:'按任务',
                            name:'task_name',
                        },
                        {
                            display_name:'按子任务',
                            name:'sub_task_name',
                        },
                    ];
                    this.createDimensionList = [
                        {
                            display_name:'按账户',
                            name:'account_create_time',
                        },
                        {
                            display_name:'按任务',
                            name:'task_create_date',
                        },
                        {
                            display_name:'按子任务',
                            name:'sub_task_create_date',
                        },
                    ];
                    this.yyTypeDimensionList = [
                        {
                            display_name:'按集团',
                            name:'bloc_yy_type',
                        },
                        {
                            display_name:'按客户',
                            name:'company_yy_type',
                        },
                        {
                            display_name:'按账户',
                            name:'account_yy_type',
                        },
                        {
                            display_name:'按项目',
                            name:'project_yy_type',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_yy_type',
                        },
                        {
                            display_name:'按产品',
                            name:'app_yy_type',
                        },
                        {
                            display_name:'按任务',
                            name:'task_yy_type',
                        },
                        {
                            display_name:'按子任务',
                            name:'sub_task_yy_type',
                        },
                    ];
                }else if(this.platId=='8'){
                    this.dimensionList = [
                        {
                            display_name:'按集团',
                            name:'bloc_name',
                        },
                        {
                            display_name:'按客户',
                            name:'company_name',
                        },
                        {
                            display_name:'按账户',
                            name:'account_name',
                        },
                        {
                            display_name:'按项目',
                            name:'project_name',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_name',
                        },
                        {
                            display_name:'按产品',
                            name:'app_name',
                        },
                        {
                            display_name:'按广告系列',
                            name:'plan_name',
                        },
                        {
                            display_name:'按广告',
                            name:'adgroup_name',
                        },
                        {
                            display_name:'按创意',
                            name:'ad_name',
                        },
                    ];
                    this.createDimensionList = [
                        {
                            display_name:'按账户',
                            name:'account_create_time',
                        },
                        {
                            display_name:'按广告系列',
                            name:'plan_create_date',
                        },
                        {
                            display_name:'按广告',
                            name:'adgroup_create_date',
                        },
                        {
                            display_name:'按创意',
                            name:'ad_create_date',
                        },
                    ];
                    this.yyTypeDimensionList = [
                        {
                            name:'bloc_yy_type',
                            display_name:'按集团',
                        },
                        {
                            name:'company_yy_type',
                            display_name:'按客户',
                        },
                        {
                            name:'account_yy_type',
                            display_name:'按账户',
                        },
                        {
                            display_name:'按项目',
                            name:'project_yy_type',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_yy_type',
                        },
                        {
                            name:'app_yy_type',
                            display_name:'按产品',
                        },
                        {
                            name:'plan_yy_type',
                            display_name:'按广告系列',
                        },
                        {
                            name:'adgroup_yy_type',
                            display_name:'按广告',
                        },
                        {
                            name:'ad_yy_type',
                            display_name:'按创意',
                        },
                    ];

                } else if(this.platId=='9'){
                    this.dimensionList = [
                        {
                            display_name:'按集团',
                            name:'bloc_name',
                        },
                        {
                            display_name:'按客户',
                            name:'company_name',
                        },
                        {
                            display_name:'按广告系列组',
                            name:'account_name',
                        },
                        {
                            display_name:'按项目',
                            name:'project_name',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_name',
                        },
                        {
                            display_name:'按产品',
                            name:'app_name',
                        },
                        {
                            display_name:'按广告系列',
                            name:'plan_name',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_name',
                        },
                        {
                            display_name:'按关键词',
                            name:'keyword',
                        },
                        {
                            display_name:'按搜索词',
                            name:'search_term',
                        },
                        {
                            display_name:'按广告',
                            name:'ad_name',
                        },
                    ].filter(item=>{
                        if(this.isTimeFilter){
                            return item.name!='search_term'&&item.name!='ad_name'&&item.name!='ad_create_date';
                        }else{
                            return true;
                        }
                    });
                    this.createDimensionList = [
                        {
                            display_name:'按广告系列',
                            name:'plan_create_date',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_create_date',
                        },
                        {
                            display_name:'按关键词',
                            name:'keyword_create_date',
                        },
                        {
                            display_name:'按广告',
                            name:'ad_create_date',
                        },
                    ].filter(item=>{
                        if(this.isTimeFilter){
                            return item.name!='search_term'&&item.name!='ad_name'&&item.name!='ad_create_date';
                        }else{
                            return true;
                        }
                    });
                    this.yyTypeDimensionList = [
                        {
                            display_name:'按集团',
                            name:'bloc_yy_type',
                        },
                        {
                            display_name:'按客户',
                            name:'company_yy_type',
                        },
                        {
                            display_name:'按广告系列组',
                            name:'account_yy_type',
                        },
                        {
                            display_name:'按项目',
                            name:'project_yy_type',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_yy_type',
                        },
                        {
                            display_name:'按产品',
                            name:'app_yy_type',
                        },
                        {
                            display_name:'按广告系列',
                            name:'plan_yy_type',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_yy_type',
                        },
                        {
                            display_name:'按关键词',
                            name:'keyword_yy_type',
                        },
                    ];
                }else if(this.platId=='7'){
                    this.dimensionList = [
                        {
                            display_name:'按集团',
                            name:'bloc_name',
                        },
                        {
                            display_name:'按客户',
                            name:'company_name',
                        },
                        {
                            display_name:'按账户',
                            name:'account_name',
                        },
                        {
                            display_name:'按项目',
                            name:'project_name',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_name',
                        },
                        {
                            display_name:'按产品',
                            name:'app_name',
                        },
                        {
                            display_name:'按计划',
                            name:'plan_name',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_name',
                        },
                        {
                            display_name:'按创意',
                            name:'ad_name',
                        },
                    ];
                    this.createDimensionList = [
                        {
                            display_name:'按账户',
                            name:'account_create_time',
                        },
                        {
                            display_name:'按计划',
                            name:'plan_create_date',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_create_date',
                        },
                        {
                            display_name:'按创意',
                            name:'ad_create_date',
                        },
                    ];
                    this.yyTypeDimensionList = [
                        {
                            name:'bloc_yy_type',
                            display_name:'按集团',
                        },
                        {
                            name:'company_yy_type',
                            display_name:'按客户',
                        },
                        {
                            name:'account_yy_type',
                            display_name:'按账户',
                        },
                        {
                            name:'project_yy_type',
                            display_name:'按项目',
                        },
                        {
                            name:'subproject_yy_type',
                            display_name:'按推广',
                        },
                        {
                            name:'app_yy_type',
                            display_name:'按产品',
                        },
                        {
                            name:'plan_yy_type',
                            display_name:'按计划',
                        },
                        {
                            name:'adgroup_yy_type',
                            display_name:'按广告组',
                        },
                        {
                            name:'ad_yy_type',
                            display_name:'按创意',
                        },
                    ];
                }else if(this.platId=='12'){
                    this.dimensionList = [
                        {
                            display_name:'按集团',
                            name:'bloc_name',
                        },
                        {
                            display_name:'按客户',
                            name:'company_name',
                        },
                        {
                            display_name:'按账户',
                            name:'account_name',
                        },
                        {
                            display_name:'按计划',
                            name:'plan_name',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_name',
                        },
                        {
                            display_name:'按创意',
                            name:'ad_name',
                        },
                    ];
                    this.createDimensionList = [
                        {
                            display_name:'按账户',
                            name:'account_create_time',
                        },
                        {
                            display_name:'按计划',
                            name:'plan_create_date',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_create_date',
                        },
                        {
                            display_name:'按创意',
                            name:'ad_create_date',
                        },
                    ];
                    this.yyTypeDimensionList = [
                        {
                            name:'bloc_yy_type',
                            display_name:'按集团',
                        },
                        {
                            name:'company_yy_type',
                            display_name:'按客户',
                        },
                        {
                            name:'account_yy_type',
                            display_name:'按账户',
                        },
                        {
                            name:'project_yy_type',
                            display_name:'按项目',
                        },
                        {
                            name:'subproject_yy_type',
                            display_name:'按推广',
                        },
                        {
                            name:'app_yy_type',
                            display_name:'按产品',
                        },
                        {
                            name:'plan_yy_type',
                            display_name:'按计划',
                        },
                        {
                            name:'adgroup_yy_type',
                            display_name:'按广告组',
                        },
                        {
                            name:'ad_yy_type',
                            display_name:'按创意',
                        },
                    ];
                }else{
                    this.dimensionList = [
                        {
                            display_name:'按集团',
                            name:'bloc_name',
                        },
                        {
                            display_name:'按客户',
                            name:'company_name',
                        },
                        {
                            display_name:'按账户',
                            name:'account_name',
                        },
                        {
                            display_name:'按项目',
                            name:'project_name',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_name',
                        },
                        {
                            display_name:'按产品',
                            name:'app_name',
                        },
                        {
                            display_name:'按计划',
                            name:'plan_name',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_name',
                        },
                        {
                            display_name:'按创意',
                            name:'ad_name',
                        },
                    ];
                    this.createDimensionList = [
                        {
                            display_name:'按账户',
                            name:'account_create_time',
                        },
                        {
                            display_name:'按计划',
                            name:'plan_create_date',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_create_date',
                        },
                        {
                            display_name:'按创意',
                            name:'ad_create_date',
                        },
                    ];
                    this.yyTypeDimensionList = [
                        {
                            name:'bloc_yy_type',
                            display_name:'按集团',
                        },
                        {
                            name:'company_yy_type',
                            display_name:'按客户',
                        },
                        {
                            name:'account_yy_type',
                            display_name:'按账户',
                        },
                        {
                            display_name:'按项目',
                            name:'project_yy_type',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_yy_type',
                        },
                        {
                            name:'app_yy_type',
                            display_name:'按产品',
                        },
                        {
                            name:'plan_yy_type',
                            display_name:'按计划',
                        },
                        {
                            name:'adgroup_yy_type',
                            display_name:'按广告组',
                        },
                        {
                            name:'ad_yy_type',
                            display_name:'按创意',
                        },
                    ];
                }
            },
            showModal() {
                this.dialogVisible = true;
                this.makeDimensionList();
                console.log('this.modalData.order_by', this.modalData.order_by, this.modalData)
                this.formItem.sum_type = this.modalData.name=='date'?this.modalData.sum_type:'';
                this.formItem.start_date_dimension = this.modalData.name=='start_date'?this.modalData.start_date_dimension||'app_name':'';
                this.formItem.create_date_dimension = this.modalData.name=='create_date'?this.modalData.create_date_dimension||'account_create_time':'';
                this.formItem.yy_type_dimension = this.modalData.name=='yy_type'?this.modalData.yy_type_dimension||'bloc_yy_type':'';
                this.formItem.order_by = this.modalData.order_by||(this.modalData.name=='date'?'date':this.modalData.name=='time_interval'?'time_interval':'');
                this.formItem.order_type = this.modalData.order_type||'desc';
                this.formItem.show_type = this.modalData.show_type||'1';
                this.formItem.show_num = this.modalData.show_num||null;
                this.formItem.display_name = this.modalData.display_name||'';

                if(this.modalData.name=='start_date'){
                    this.lastSelectVal = this.formItem.start_date_dimension;
                }else if(this.modalData.name=='create_date'){
                    this.lastSelectVal = this.formItem.create_date_dimension;
                }else if(this.modalData.name=='yy_type'){
                    this.lastSelectVal = this.formItem.yy_type_dimension;
                }


                this.$nextTick(()=>{
                    let checkedData = [...this.selectTarget]
                    let flatData = [];
                    this.allField.forEach(item => {
                        if (item.children && item.children.length > 0) {
                            flatData = flatData.concat(item.children.map(inner=>{
                                if(item.name.includes('_sum_data')){
                                    inner.isSumField = true;
                                }
                                return inner;
                            }));
                        }
                    });
                    flatData.forEach(item=>{
                        checkedData.map(itemc=>{
                            if(itemc['name'] == item['name']) {
                                itemc['display_name'] = item['display_name']
                            }
                            return itemc
                        })
                        if(checkedData.findIndex(inner=>inner.name==item.name)===-1){
                            checkedData.push(item);
                        }
                    });

                    this.allFieldList = checkedData;
                })
            },
            handleSubmit() {
                if(this.modalData && this.modalData['type'] == 'info') {
                    this.$nextTick(()=>{
                        this.handleClose();
                    })
                    return
                }
                this.$refs['form'].validate((valid) => {
                    if (valid) {

                        let dimensionSortCount = 0;
                        this.dimensions.filter(item=>item.name!=this.modalData.name).forEach(item=>{
                            if(item.name==='date'||item.name==='time_interval'){
                                dimensionSortCount++
                            }else{
                                if(item.order_by!=''){
                                    dimensionSortCount++
                                }
                            }
                        });

                        //全部维度
                        let is_equal_all_dimensions = this.allDimensions.some(item=>{
                            let r_boolean = false
                            item['children'] && item['children'].forEach(el=>{
                                if(el['name'] != this.modalData['name'] && el['display_name'] == this.formItem.display_name) {
                                    r_boolean = true
                                }
                            })
                            return r_boolean
                        })

                        //选中维度
                        let is_equal_select_dimensions = this.dimensions.filter(item=>item['name'] != this.modalData['name']).some(item=>item['display_name'] == this.formItem.display_name)

                        //全部指标
                        let is_equal_all_target = this.allFieldList.some(item=>item['display_name'] == this.formItem.display_name)
                        //选中指标
                        let is_equal_select_target = this.selectTarget.some(item=>item['display_name'] == this.formItem.display_name)

                        // console.log('全部维度', is_equal_all_dimensions)
                        // console.log('选中维度', is_equal_select_dimensions)
                        // console.log('全部维度', is_equal_all_target)
                        // console.log('选中维度', is_equal_select_target)

                        if(this.formItem.order_by&&dimensionSortCount>10){
                            return this.$message.error('最多可设置10个维度的排序');
                        }

                        if(this.formItem.display_name == ''){
                            return this.$message.error('名称必填项，不可为空');
                        }

                        if(is_equal_all_dimensions || is_equal_select_dimensions || is_equal_all_target || is_equal_select_target){
                            return this.$message.error('名称重复，请修改');
                        }


                        let data={
                            order_by: this.formItem.order_by,
                            order_type: this.formItem.order_by?this.formItem.order_type:'',
                            show_num: this.formItem.order_by?this.formItem.show_num:'',
                            show_type: this.formItem.order_by?this.formItem.show_type:'',
                            start_date_dimension:this.formItem.start_date_dimension,
                            create_date_dimension:this.formItem.create_date_dimension,
                            yy_type_dimension:this.formItem.yy_type_dimension,
                            sum_type: this.formItem.sum_type,
                            name: this.modalData['name'],
                            // display_name: this.modalData['display_name'],
                            display_name: this.formItem.display_name

                        };
                        console.log('data', data)
                        this.$emit('save-value', data);
                        this.$nextTick(()=>{
                            this.handleClose();
                        })
                    } else {
                        return false;
                    }
                });
            },
            clearOrderBy(){
                if(this.modalData.name=='date'){
                    this.formItem.order_by = 'date';
                }else if(this.modalData.name=='time_interval'){
                    this.formItem.order_by = 'time_interval';
                }
            },
            changeOrderBy(val){
                /* 判断维度中有排序的个数，超过10个后禁止设置 */

                console.log('-', this.dimensions)

                let dimensionSortCount = 0;
                this.dimensions.filter(item=>item.name!=this.modalData.name).forEach(item=>{
                    if(item.name==='date'||item.name==='time_interval'){
                        dimensionSortCount++
                    }else{
                        if(item.order_by != ''){
                            dimensionSortCount++
                        }
                    }
                });
                if(val&&dimensionSortCount>=10){
                    this.$message.error('最多可设置10个维度的排序');
                    if(this.modalData.name!='date'&&this.modalData.name!='time_interval'){
                        this.formItem.order_by = '';
                    }
                }
            },
            changeSumType(){
                // this.$emit('change-sum-type');
            },
            checkAppleSelect(val){
                if(this.platId!='9') return false;
            },
        },
    }
</script>

<style lang="scss" scoped>
    .action-btn {
        /*width: 120px;*/
    }

    ::v-deep .el-dialog__body{
        padding: 20px;
    }

</style>
